import { Installer, ModuleIsEnabledFilter } from '@gongxigames/framework/core';
import { DI } from '@gongxigames/framework/slot/configs/DI';
import { PromotionTypes, ILogicPromotionFunctional } from '@gongxigames/framework/promotions';

export function isEnabledPromotionType(promotionType: PromotionTypes): ModuleIsEnabledFilter {
    return (components: Installer): boolean => {
        const fr = components.getComponent<ILogicPromotionFunctional>(DI.Logic).getPromotion();

        return fr && promotionType === fr.type;
    };
}
